<span *ngIf="enumListObj.hasOwnProperty(enumValue)">{{enumListObj[enumValue]}}</span>
